import React from 'react';
import { FormPermissoes } from '../../components/FormPermissoes';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';


export default function CadastrarPermissoesPage() {

   const defaultValues = {
        'nome': '',
        'permissoes': []
   }

  return (
    <div className="p-pt-0">
      <MenuMain >
        <FormPermissoes defaultValues={{defaultValues}} />
      </MenuMain>
      <AppFooter />
    </div>
  );
}
